import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import 'aos/dist/aos.css'; // Import AOS styles
import AOS from 'aos'; // Import AOS library
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsAndConditions = () => {
  const [visibleItems, setVisibleItems] = useState([]);
  const itemRefs = useRef([]);
  const videoRef = useRef(null);

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);

    // Initialize AOS
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-in-out',
    });

    // Google Analytics
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'G-P2TS4436R5');

    // Intersection Observer for animated items
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleItems((prev) => [...prev, entry.target.dataset.index]);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    itemRefs.current.forEach((item) => {
      if (item) observer.observe(item);
    });

    // Parallax effect for video
    const handleScroll = () => {
      if (videoRef.current) {
        const scrollPosition = window.scrollY;
        const videoHeight = videoRef.current.offsetHeight;
        const translateY = scrollPosition * 0.3;
        videoRef.current.style.transform = `translateY(${translateY}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      itemRefs.current.forEach((item) => {
        if (item) observer.unobserve(item);
      });
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans">
      <Helmet>
        <title>Terms & Conditions | SecurXpert Technologies - Hyderabad</title>
        <meta
          name="description"
          content="Meet the brilliant minds behind SecurXpert Technologies – Our CoreXperts. Explore our teams in Technology, Strategy, and Business Process Services."
        />
        <meta
          name="keywords"
          content="SecurXpert team, CoreXperts, IT professionals Hyderabad, digital innovation, technology strategy"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://securxperts.com/terms" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Terms and Conditions",
            "url": "https://securxperts.com/terms",
            "publisher": {
              "@type": "Organization",
              "name": "SecurXpert Technologies",
              "url": "https://securxperts.com",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Hyderabad",
                "addressCountry": "IN",
              },
            },
          })}
        </script>
      </Helmet>

      <Navbar />

      {/* Hero Section with Video */}


    <header className="relative w-full">
  <div
    className="relative w-full h-[317px] bg-center bg-cover bg-no-repeat"
    style={{ backgroundImage: `url('/img/termsbanner.png')` }}
    
  >
    {/* Dark overlay */}
    <div className="absolute inset-0 bg-black/70 lg:bg-black/60" />

    {/* Centered text content */}
    <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 drop-shadow-md">
       Terms & Conditions
      </h1>

      <div className="flex items-center gap-2 text-sm sm:text-base">
        <Link to="/" className="hover:underline">Home</Link>
        <svg
          width="7"
          height="10"
          viewBox="0 0 7 10"
          fill="none"
          className="mt-[2px]"
        >
          <path
            d="M0.297 0.262C0.105 0.426 -0.002 0.648 0 0.878C0.002 1.109 0.113 1.329 0.308 1.492L4.02 4.604L0.366 7.711C0.173 7.875 0.067 8.097 0.069 8.328C0.071 8.558 0.182 8.778 0.377 8.941C0.474 9.022 0.59 9.086 0.717 9.13C0.844 9.174 0.981 9.196 1.118 9.195C1.255 9.194 1.391 9.171 1.518 9.126C1.644 9.081 1.758 9.016 1.854 8.933L6.232 5.212C6.329 5.131 6.405 5.034 6.457 4.927C6.509 4.821 6.535 4.706 6.534 4.591C6.533 4.476 6.505 4.362 6.451 4.256C6.397 4.15 6.319 4.054 6.221 3.974L1.774 0.254C1.677 0.173 1.561 0.109 1.434 0.065C1.307 0.021 1.171 -0.001 1.033 0C0.896 0.001 0.76 0.024 0.634 0.069C0.507 0.114 0.393 0.18 0.297 0.262Z"
            fill="white"
          />
        </svg>
        <span>Terms & Conditions</span>
      </div>
    </div>
  </div>
</header>


      {/* Content Section */}
      <section className="py-12 sm:py-16 md:py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2
            className="text-center text-base xs:text-lg sm:text-xl md:text-2xl font-bold text-blue-900 no-underline mb-8 sm:mb-12 tracking-tight"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            Effective Date: 18/02/2025
          </h2>
          <p
            className="text-sm xs:text-base sm:text-lg font-normal text-gray-800 no-underline mb-8 sm:mb-12 text-center"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Welcome to SecurXpert Technologies Pvt Ltd. These Terms and Conditions govern your access and use of our website, mobile application, and services. By using our platform, you agree to comply with these terms. If you do not agree, please do not use our services.
          </p>

          {[
            {
              title: '1. Introduction',
              content: 'These Terms and Conditions constitute a legally binding agreement between you and SecurXpert Technologies Pvt Ltd. By accessing or using our website and services, you confirm your acceptance of these terms.',
            },
            {
              title: '2. Definitions',
              content: (
                <>
                  <strong className="text-gray-800 no-underline">"Company," "we," "our," or "us"</strong> refers to SecurXpert Technologies Pvt Ltd.<br />
                  <strong className="text-gray-800 no-underline">"User," "you," or "your"</strong> refers to any individual or entity accessing our services.<br />
                  <strong className="text-gray-800 no-underline">"Services"</strong> include our website, mobile application, and any related products or offerings.
                </>
              ),
            },
            {
              title: '3. Use of Our Services',
              content: (
                <>
                  You must be at least 18 years old to use our services. Minors must obtain parental or guardian consent.<br />
                  You agree to provide accurate and complete information during registration and maintain the confidentiality of your account credentials.<br />
                  You are responsible for all activities under your account.
                </>
              ),
            },
            {
              title: '4. Medical Disclaimer',
              content: (
                <>
                  The information provided on our platform is for informational purposes only and does not constitute medical advice.<br />
                  Our AI-driven health assistant and recommendations are not a substitute for professional medical diagnosis or treatment. Always consult a qualified healthcare provider for medical concerns.
                </>
              ),
            },
            {
              title: '5. Ordering and Subscription Services',
              content: (
                <>
                  We provide medicine ordering, subscriptions, and lab test services through our platform.<br />
                  Orders are subject to availability, prescription verification, and regulatory compliance.<br />
                  Subscription plans renew automatically unless canceled by the user.
                </>
              ),
            },
            {
              title: '6. Payment and Fees',
              content: (
                <>
                  All payments must be made through the accepted payment methods available on our platform.<br />
                  Prices are subject to change at our discretion.<br />
                  Subscription and service fees are non-refundable unless stated otherwise.
                </>
              ),
            },
            {
              title: '7. Delivery Policy',
              content: 'We offer hyperlocal medicine delivery with estimated timelines. However, delivery times may vary due to external factors.',
            },
            {
              title: '8. User Conduct and Restrictions',
              content: (
                <>
                  You must not misuse our platform for fraudulent activities.<br />
                  You agree not to copy, modify, distribute, or exploit our content without authorization.<br />
                  We reserve the right to suspend or terminate accounts engaging in prohibited activities.
                </>
              ),
            },
            {
              title: '9. Intellectual Property Rights',
              content: (
                <>
                  All trademarks, logos, content, and software are owned by SecurXpert Technologies Pvt Ltd.<br />
                  Unauthorized use of our intellectual property is strictly prohibited.
                </>
              ),
            },
            {
              title: '10. Limitation of Liability',
              content: (
                <>
                  We are not responsible for any indirect, incidental, or consequential damages arising from your use of our services.<br />
                  Our platform is provided on an "as-is" basis without warranties of any kind.
                </>
              ),
            },
            {
              title: '11. Privacy Policy',
              content: (
                <>
                  By using our services, you agree to our Privacy Policy, which governs data collection, storage, and usage.<br />
                  We use encryption and security measures to protect user data.
                </>
              ),
            },
            {
              title: '12. Termination of Services',
              content: (
                <>
                  We reserve the right to suspend or terminate services at our sole discretion if you violate these terms.<br />
                  Users may discontinue use of our services at any time.
                </>
              ),
            },
            {
              title: '13. Amendments to Terms',
              content: 'We may update these Terms and Conditions at any time. Changes will be notified via our website or mobile app.',
            },
            {
              title: '14. Governing Law and Dispute Resolution',
              content: (
                <>
                  These terms shall be governed by the laws of India.<br />
                  Any disputes arising shall be resolved through arbitration or legal proceedings in Hyderabad, Telangana.
                </>
              ),
            },
            {
              title: '15. Contact Information',
              content: (
                <>
                  <div className="contact-info bg-gray-100 p-5 rounded-lg border-l-4 border-cyan-400 text-sm xs:text-base sm:text-lg text-gray-800 no-underline">
                    If you have any questions about these Terms and Conditions, please contact us:<br />
                    SecurXpert Technologies Pvt Ltd<br />
                    5th Floor, Krishna Towers (Square Hub), 100 Feet Rd, Madhapur, Hyderabad, Telangana 500081<br />
                    Phone: +91 7993256679<br />
                    <a
                      href="mailto:info@SecurXperts.com"
                      className="relative text-cyan-400 hover:text-cyan-300 transition-transform duration-300 hover:scale-105 no-underline after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-0 after:bg-gradient-to-r after:from-cyan-400 after:to-blue-300 after:transition-all after:duration-300 hover:after:w-full"
                      aria-label="Email SecurXpert"
                      title="Contact us via email"
                    >
                      info@SecurXperts.com
                    </a>
                  </div>
                  <p className="last-updated text-sm xs:text-base sm:text-lg text-gray-500 no-underline mt-4 italic font-light">
                    Last Updated: 20/03/2025
                  </p>
                  <p className="text-sm xs:text-base sm:text-lg text-gray-800 no-underline mt-2">
                    By using our platform, you acknowledge that you have read and understood these Terms and Conditions. Your continued use constitutes acceptance of any updates made to these terms.
                  </p>
                </>
              ),
            },
          ].map((section, index) => (
            <div
              className="section bg-gray-100/80 p-4 sm:p-6 mb-8 sm:mb-10 border-b border-cyan-400/20 sm:border-0 hover:bg-gray-200/80 hover:scale-105 hover:shadow-xl transition-all duration-500 ease-in-out"
              key={index}
              data-index={index + 1}
              ref={(el) => (itemRefs.current[index + 1] = el)}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <h2
                className="text-base xs:text-lg sm:text-xl md:text-2xl font-bold text-blue-900 no-underline mb-4 tracking-tight"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                {section.title}
              </h2>
              <p
                className="text-sm xs:text-base sm:text-lg font-normal text-gray-800 no-underline leading-relaxed"
                data-aos="fade-up"
                data-aos-delay={(index + 1) * 100}
              >
                {section.content}
              </p>
            </div>
          ))}
        </div>
      </section>

      <Footer />

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-4 sm:bottom-6 right-4 sm:right-6 bg-gradient-to-r from-blue-500 to-blue-700 p-3 sm:p-4 rounded-full shadow-xl hover:from-blue-600 hover:to-blue-800 transition"
        aria-label="Back to top"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 sm:w-6 h-5 sm:h-6 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
        </svg>
      </button>
    </div>
  );
};

export default TermsAndConditions;